const $selectBoxes = document.querySelectorAll(".select-box");

const handleSelectBoxClick = (e) => {};

const updateSelectBoxSelection = ($box) => {
  const $sb_checkedInput = $box.querySelector(
    ".select-box_values input:checked"
  );
  const $sb_selection = $box.querySelector(".select-box_selection");
  const selected_value = $sb_checkedInput.value;
  $sb_selection.textContent = selected_value;
};

const onSelectBoxClick = (e) => {
  if (e.target.tagName == "INPUT") return;
  const $box = e.currentTarget;

  // Update selection value
  // The event loop first runs JavaScript event handlers, then updates the DOM.
  // So when your handler runs, the <input> you just clicked hasn't changed state yet.

  requestAnimationFrame(() => {
    updateSelectBoxSelection($box);
  });

  // open or close select box
  if ($box.classList.contains("open")) {
    $box.classList.remove("open");
  } else {
    const $openedBox = document.querySelector(".select-box.open");
    if ($openedBox) {
      $openedBox.classList.remove("open");
    }

    $box.classList.add("open");
  }
};


$selectBoxes.forEach(($box) => {
  // set initial selected value
  // updateSelectBoxSelection($box);

  // Event listener for select-box
  $box.addEventListener("click", onSelectBoxClick);
});